const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const styles = require("./styles/LockIcon.css");

module.exports = createReactClass({
	displayName: "LockIcon",

	propTypes: {
		className: PT.string,
		isLocked: PT.bool,
		isForced: PT.bool,
		hoverContent: PT.string,
		alwaysDark: PT.bool, // Used in admin pages to force the darker hover color
		onLockSelection: PT.func,
		disabled: PT.bool,
		lockColorOverride: PT.string,
		useKeyIcon: PT.bool,
		hidden: PT.bool,
	},

	getInitialState: function() {
		return {
			isHovering: false,
		};
	},

	onHoverStart: function() {
		this.setState({isHovering: true});
	},

	onHoverEnd: function() {
		this.setState({isHovering: false});
	},

	toggleChoice: function(evt) {
		evt.stopPropagation();

		const {onLockSelection, disabled} = this.props;
		if (!disabled && onLockSelection) {
			onLockSelection();
			this.setState({isHovering: false});
		}
	},

	render: function() {
		const {
			hidden,
			disabled,
			isLocked,
			isForced,
			hoverContent,
			lockColorOverride = "",
			useKeyIcon,
		} = this.props;
		const {isHovering} = this.state;

		let hoverEl = null;
		if (isHovering && hoverContent) {
			hoverEl = <div className={styles.hoverContent}>{hoverContent}</div>;
		}

		const lockColorClass = isForced
			? styles.forceLockColor
			: lockColorOverride || styles.lockColor;

		let imgEl;
		if (useKeyIcon && !isForced) {
			imgEl = makeKeySVG(lockColorClass);
		} else if (isLocked) {
			imgEl = makeLockedSVG(lockColorClass);
		} else {
			imgEl = makeUnlockedSVG(lockColorClass);
		}

		let mainClass = disabled ? styles.main : styles.mainHoverable;
		if (this.props.alwaysDark) {
			mainClass = styles.mainDark;
		}
		mainClass += " " + this.props.className;

		let mainStyle = null;
		if (hidden) {
			mainStyle = {visibility: "hidden"};
		}

		return (
			<div className={mainClass} style={mainStyle}>
				<div
					className={styles[isHovering ? "expandedHoverable" : "hoverable"]}
					onMouseEnter={this.onHoverStart}
					onMouseLeave={this.onHoverEnd}
					onClick={this.toggleChoice}
				>
					{hoverEl}
				</div>
				{imgEl}
			</div>
		);
	},
});

const makeKeySVG = function(svgClass) {
	return (
		<svg
			version="1.1"
			x="0px"
			y="0px"
			viewBox="0 0 28 28"
			width="28"
			height="28"
			preserveAspectRatio="none"
			className={styles.icon}
		>
			<g className={svgClass}>
				<path d="M23.17184,2.88947,12.81612,13.24518a7.6947,7.6947,0,1,0,3.52967,3.52966l5.56775-5.56775,2.688,2.688,3.63525-3.63524-2.688-2.688L26.7015,6.41913ZM11.29419,21.96927a2.59685,2.59685,0,1,1,0-3.6726A2.59682,2.59682,0,0,1,11.29419,21.96927Z" />
			</g>
		</svg>
	);
};

const makeLockedSVG = function(svgClass) {
	return (
		<svg
			version="1.1"
			x="0px"
			y="0px"
			viewBox="0 0 28 28"
			width="28"
			height="28"
			preserveAspectRatio="none"
			className={styles.icon}
		>
			<path
				className={svgClass}
				d="M18,11.5h-0.7V9.2c0-3.9-3.2-7.1-7.1-7.1c-3.9,0-7.1,3.2-7.1,7.1v2.3H2.3c-0.9,0-1.6,0.7-1.6,1.6v11 c0,0.9,0.7,1.6,1.6,1.6H18c0.9,0,1.6-0.7,1.6-1.6v-11C19.6,12.3,18.9,11.5,18,11.5z M12,22.5c0.1,0.3-0.2,0.6-0.5,0.6H8.8 c-0.3,0-0.6-0.3-0.5-0.6l0.7-3.8c-0.4-0.3-0.7-0.9-0.7-1.4c0-1,0.8-1.9,1.9-1.9c1,0,1.9,0.8,1.9,1.9c0,0.6-0.3,1.1-0.7,1.4L12,22.5 z M13,11.5H7.2V9.2c0-1.6,1.3-2.9,2.9-2.9c1.6,0,2.9,1.3,2.9,2.9V11.5z"
			/>
		</svg>
	);
};

const makeUnlockedSVG = function(svgClass) {
	return (
		<svg
			version="1.1"
			x="0px"
			y="0px"
			viewBox="0 0 28 28"
			width="28"
			height="28"
			preserveAspectRatio="none"
			className={styles.icon}
		>
			<g className={svgClass}>
				<path d="M20.2,2.2c-3.9,0-7.1,3.2-7.1,7.1v2.3H7.2H3.1H2.3c-0.9,0-1.6,0.7-1.6,1.6v11c0,0.9,0.7,1.6,1.6,1.6H18 c0.9,0,1.6-0.7,1.6-1.6v-11c0-0.9-0.7-1.6-1.6-1.6h-0.7h0V9.2c0-1.6,1.3-2.9,2.9-2.9c1.6,0,2.9,1.3,2.9,2.9v4.2h4.2V9.2 C27.3,5.3,24.1,2.2,20.2,2.2z M12,22.5c0.1,0.3-0.2,0.6-0.5,0.6H8.8c-0.3,0-0.6-0.3-0.5-0.6l0.7-3.8c-0.4-0.3-0.7-0.9-0.7-1.4 c0-1,0.8-1.9,1.9-1.9c1,0,1.9,0.8,1.9,1.9c0,0.6-0.3,1.1-0.7,1.4L12,22.5z" />
			</g>
		</svg>
	);
};
